/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExamAttemptStatusUsed } from './examAttemptStatusUsed';
import type { ExamAttemptStatusAllowed } from './examAttemptStatusAllowed';
import type { ExamAttemptStatusSupportEmail } from './examAttemptStatusSupportEmail';
import type { ExamAttemptStatusLatestFailureReason } from './examAttemptStatusLatestFailureReason';
import type { GradedAttemptTab } from './gradedAttemptTab';

/**
 * Student-facing exam attempt snapshot. The client must not recompute this.
 */
export interface ExamAttemptStatus {
  enabled?: boolean;
  nextAction?: string;
  used?: ExamAttemptStatusUsed;
  allowed?: ExamAttemptStatusAllowed;
  supportEmail?: ExamAttemptStatusSupportEmail;
  latestFailureReason?: ExamAttemptStatusLatestFailureReason;
  gradedAttempts?: GradedAttemptTab[];
}
